import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      richColors
      toastOptions={{
        classNames: {
          toast:
            "group toast bg-white text-slate-900 border border-slate-200 shadow-lg",
          description: "text-slate-600",
          actionButton:
            "bg-orange-500 text-white",
          cancelButton:
            "bg-slate-100 text-slate-600",
        },
      }}
      {...props}
    />
  );
}

export { Toaster, toast }
